<template>
  <div
    class="privacy-policy"
  >
    <h1>PRIVACY POLICY</h1>
    <h3>1. Foreword</h3>
    <p class="ml-6">
      1. The Company enables users (hereinafter the “User”) navigating on the website soraremega.com (hereinafter the “Website”) to benefit from an enhanced user interface. SorareMega is a global fantasy football game where Users can play with officially licensed digital cards and earn prizes every week. The Website provides a marketplace for its registered Users for acquiring, collecting and exchanging Collectibles and their underlying tokens which are based on blockchain technology. (the aforementioned activities, collectively, the “Services”).
    </p>

    <h3>2. Personal data</h3>
    <p class="ml-6">
      1. To use the Services, the User shall connect through an external sorare.com account using an oAuth protocol on the Website.
    </p>
    <p class="ml-6">
      2. When the User logs in the Company website, the information accessed by the Company is clearly stated, for example your nickname and your avatar can be accessed by the Company whereas your email address can not.
    </p>
    <p class="ml-6">
      3. Thus the Company doesn’t own nor have access to any personal data tied to the User sorare account, this User personal data remains strictly under the property of sorare.com.
    </p>

    <h3>3. Scope</h3>
    <p class="ml-6">
      1. This privacy policy (“Policy”) is intended to inform you, as a visitor or a User of the Services, through any terminal, application, device (hereinafter the “Services”), including with an account, about the way the Company processes, as controller, cookies in the context of your use of the Services.
    </p>
    <p class="ml-6">
      2. By agreeing on this Policy, the User allows the use of cookies by the Company in line with this Policy.
    </p>
    <p class="ml-6">
      3. The Policy is accessible at any time on the Website and prevails over any previous version.
    </p>
    <p class="ml-6">
      4. The Policy may evolve. The up-to-date version is the one available on the Website.
    </p>

    <h3>4. Cookies</h3>
    <p class="ml-6">
      1. When you browse our Website, cookies are placed on your termina after having obtained your consent as required by the regulations on cookies.
    </p>
    <p class="ml-6">
      2. Cookies are pieces of information placed on the Internet user's terminal equipment by the server of the website visited. They are used by a website to send information to the Internet user's browser and to allow this browser to send information back to the website of origin (for example, a session identifier or the choice of a language).
    </p>
    <p class="ml-6">
      3. Only the sender of a cookie can read or modify the information contained in it.
    </p>
    <div class="ml-6">
      4. There are different types of cookies :
      <ul>
        <li>session cookies that disappear as soon as you leave the Website</li>
        <li>permanent cookies that remain on your terminal until their lifetime expires or until you delete them using your browser's functions</li>
      </ul>
    </div>
    <p class="ml-6">
      5. You are informed that, during your visits to the Website, cookies may be installed on your terminal equipment.
    </p>

    <h3>5. Cookies used</h3>
    <div class="ml-6">
      1.Cookies used on our Website are:
      <ul>
        <li>third party cookies chosen by the Company in order to achieve certain objectives</li>
      </ul>
    </div>
    <p class="ml-6">
      2.Cookies placed by third parties are the following:
    </p>
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Purpose</th>
          <th>Retention period</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>ga</td>
          <td>This cookie is set by Google Analytics to anonymously identify visitors to measure the update of information and potential conversion to registered users. More information on https://policies.google.com/technologies/cookies/(Google privacy policy).</td>
          <td>6 months</td>
        </tr>
        <tr>
          <td>gcl_au</td>
          <td>This cookie is set by Google Tag Manager to anonymously identify visitors to measure the update of information and potential conversion to registered users. More information on https://policies.google.com/technologies/cookies/(Google privacy policy).</td>
          <td>3 months</td>
        </tr>
        <tr>
          <td>gid</td>
          <td>This cookie is set by Google Analytics to anonymously identify visitors to measure the update of information and potential conversion to registered users. More information on https://policies.google.com/technologies/cookies/(Google privacy policy).</td>
          <td>1 day</td>
        </tr>
    </tbody>
    </table>

    <h3>6. Cookie management</h3>
    <div class="ml-6">
      1.You can manage and modify the use of cookies at any time according to the possibilities listed below:
      <ul>
        <li>directly on our Website, in the module provided for this purpose, by clicking here, or</li>
        <li>from your browser, or</li>
        <li>from interprofessional opposition platforms</li>
      </ul>
    </div>
    <p class="ml-6">
      2. You can configure your browser so that cookies are stored in your terminal equipment or are rejected, either systematically or according to their sender
    </p>
    <p class="ml-6">
      3. You can also regularly delete cookies from your terminal via your browser.
    </p>
    <p class="ml-6">
      4. However, don't forget to configure all the browsers on your various terminals (tablets, smartphones, computers...).
    </p>
    <p class="ml-6">
      5. Please note, however, that by setting your browser to reject cookies, certain features, pages and areas of the Website that require the use of cookies will not be accessible, for which we cannot be responsible.
    </p>

    <h3>7. Security</h3>
    <p class="ml-6">
      1. The Company reserves the right to change this Policy as necessary, as the Services evolves or as required by applicable laws.
    </p>
    <p class="ml-6">
      2. When using the Company’s Services, the User is deemed to have accepted the terms of the Policy when it is published on our Website.
    </p>

    <h3>8. Jurisdiction and applicable law</h3>
    <p class="ml-6">
      1. The Policy is governed and interpreted according to French and European law.
    </p>
    <p class="ml-6">
      2. Unless otherwise provided by the law, the Policy will subject Users to the exclusive jurisdiction of the French courts.
    </p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
};
</script>

<style scoped>
.privacy-policy {
  padding: 0 60px;
}

table {
  border-collapse: collapse;
  max-width: 1000px;
}

td {
  padding: 10px;
}
</style>
